import { defineMessages } from "react-intl";

export default defineMessages({
    filterTitle: {
        id: "components__version-comparator__filter--title",
        defaultMessage: "Filter",
    },
});
